import React from 'react';

import {OETarget} from '../../../react-oe/oe-target';
import OEIconCodes from '../../../lib/oe-icon-codes';
import OEProtoCapBar from '../oe-proto-cap-bar';
import {OEEarTargetType, OEEarTargets, OEEarFeatureAccess, OEEarStartSelectionData} from './oe-ear-model';

export default class OEEarCapBar extends React.PureComponent {

    constructor(props) {
        super(props);

        this.targetTypeMap = {
            [OEEarTargetType.anatomy]:          {icon: OEIconCodes.ear.anatomyTarget, noTargetTypeBarEntry: true, titleId: 'cap_bar_target_title_anatomy'},
            [OETarget.effigosExplorerHelp]:     {target: OETarget.effigosExplorerHelp, icon: OEIconCodes.help, noTargetTypeBarEntry: true, titleId: 'target_menu_effigosExplorerHelp'}
        };
    }

    render()    {
        let targetTypes = OEEarStartSelectionData.chooseModules().map(module => module.id);
        targetTypes.push(OETarget.effigosExplorerHelp);

        return (
            <OEProtoCapBar
                {...this.props}
                targetTypes={targetTypes}
                targetTypeMap={this.targetTypeMap}
                versionTargets={OEEarTargets}
                featureAccess={OEEarFeatureAccess}
                startSelectionData={OEEarStartSelectionData}
            />
        );
    }
}